import { ContentControlledSettingsAIDetections } from './content-controlled-settings-ai-detections';
import { ContentControlledVODSettings } from './content-controlled-vod-settings';
import { IContentControlledItemSettings } from './i-content-controlled-item-settings';

export class ContentControlledLiveSettings
  implements IContentControlledItemSettings {
  public readonly discriminator = 'LIVE';
  constructor(
    public aiDetections: ContentControlledSettingsAIDetections,
    public studioAllowedDeviationMs: number,
    public studioDefinedDelayMs: number
  ) { }

  clone(): IContentControlledItemSettings {
    return new ContentControlledVODSettings(this.aiDetections);
  }
  static empty() {
    return new ContentControlledVODSettings({ scalingFactor: 1 });
  }
}
